import { Type } from "../core/models/type"

export const getTypeById = (
  types: Type[] | undefined,
  id: number | undefined
): Type | undefined => {
  return types?.find((type: Type) => type.id === id)
}
